module.exports = __webpack_public_path__ + "img/empt.3762f6db.png";